import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { subscriptionsService } from '../api/subscriptions.service';

export function useSubscriptionItemsQuery(subscriptionId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.subscriptions.items(subscriptionId ?? ''),
    queryFn: () => subscriptionsService.listItems(subscriptionId!),
    enabled: enabled && !!subscriptionId,
  });
}
